<template>
  <div class="setting-online-distribution">
    <transition name="fade-transform" mode="out-in">
      <router-view/>
    </transition>

  </div>
</template>

<script>
  export default {
    name: 'setting-online-distribution',
    data() {
      return {

      }
    },
    created() {

    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<style lang="scss">
.setting-online-distribution{
  .setting-distribution-tips{
    color: #999;
    font-size: 12px;
    padding-top: 12px;
    .change-sort{
      color: $mainColor;
      cursor: pointer;
      font-weight: bold;
    }
  }
}
</style>
